import {
  ADD_PRODUCT_SUCCESS,
  GET_PRODUCTS_ERROR,
  GET_PRODUCTS_SUCCESS,
  GET_PRODUCTS,
  REMOVE_ALL_SUCCESS,
  REMOVE_PRODUCT_SUCCESS,
  REMOVE_SEARCHING_PRODUCTS,
  RESET_AMOUNTS_PRODUCTS_SUCCESS,
  SAVED_PRODUCT_SUCCESS,
  UPDATE_PRODUCTS_SAVED_SUCCESS,
  INITIAL_SAVED_PRODUCTS_DIRECT_DEAL_PRODUCTS
} from './ProductSearch.actions'

const productsState = {
  products: [],
  productsSaved: [],
  loading: false,
  error: false
}

/**
 * The ProductSearch's reducer.
 */
const productSearchReducer = (state = productsState, { payload, type }) => {
  switch (type) {
    case GET_PRODUCTS: {
      return { ...state, loading: true, error: false }
    }
    case GET_PRODUCTS_ERROR: {
      return { ...state, loading: false, error: payload.error }
    }
    case GET_PRODUCTS_SUCCESS: {
      return {
        ...state,
        products: payload.products,
        loading: false
      }
    }
    case ADD_PRODUCT_SUCCESS: {
      return {
        ...state,
        productsSaved: [...state.productsSaved, payload.newProduct]
      }
    }
    case REMOVE_PRODUCT_SUCCESS:
      return {
        ...state,
        productsSaved: state.productsSaved.filter(product => product.productKey !== payload)
      }
    case UPDATE_PRODUCTS_SAVED_SUCCESS:
      return {
        ...state,
        productsSaved: payload.products
      }
    case REMOVE_ALL_SUCCESS:
      return {
        ...state,
        productsSaved: []
      }
    case REMOVE_SEARCHING_PRODUCTS:
      return {
        ...state,
        products: []
      }
    case SAVED_PRODUCT_SUCCESS: {
      return {
        ...state,
        productsSaved: state.productsSaved.map(product =>
          product.productKey === payload.productKey ? { ...payload } : product
        )
      }
    }
    case INITIAL_SAVED_PRODUCTS_DIRECT_DEAL_PRODUCTS: {
      return {
        ...state,
        productsSaved: payload
      }
    }
    case RESET_AMOUNTS_PRODUCTS_SUCCESS: {
      return {
        ...state,
        productsSaved: state.productsSaved.map(product => {
          return {
            ...product,
            amount: '0',
            unitPrice: '0',
            discount: '0',
            charge: '0'
          }
        })
      }
    }
    default: {
      return state
    }
  }
}

export default productSearchReducer
